<template>
    <div class="template-layout hstack">
        <Sidebar :sidebarMenu="sidebarMenu" :class="{ 'sidebar-visible': isSidebarVisible }" />
        <div class="main-content content">
            <Topbar @toggle-sidebar="toggleSidebar" />
            <div
				v-show="title != 'null'"
				:class="title.length === 0 ? 'py-4' : 'py-3'"
				class="bg-light-hight- ps-5 pb-2"
			>
				{{ title }}
			</div>
            <div v-show="isOnline">
                <slot></slot>
            </div>
            <div v-show="!isOnline" class="text-center my-auto">
                <section class="p-5 py-4">
                    <div style="height: 80vh">
                        <div class="row h-100">
                            <div class="my-auto col-xl-9 mx-auto text-center">
                                <img
                                    src="images/nointernet.png"
                                    alt=""
                                    style="width: 55px; height: 55px"
                                />
                                <p class="text-black mt-2">
                                    Vous semblez ne pas avoir accès à internet
                                </p>
                                <button
                                    class="button btn-sm bg-red- text-white-"
                                    @click="updateOnlineStatus"
                                >
                                    Reéssayer
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<style>
.top-left {
	width: 263px;
	border-right: 1px solid #555;
}

.dropdown-menu li {
	position: relative;
}
.dropdown-menu .dropdown-submenu {
	display: none;
	position: absolute;
	left: 100%;
	top: -7px;
}
.dropdown-menu .dropdown-submenu-left {
	right: 100%;
	left: auto;
}
.dropdown-menu > li:hover > .dropdown-submenu {
	display: block;
}
.content {
	width: 100%;
	padding-top: 6vh;
	height: 100vh;
	overflow: auto;
}

.main-content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

@media (max-width: 768px) {
    .sidebar {
        position: fixed;
        left: -325px;
        top: 0;
        bottom: 0;
        z-index: 1000;
        transition: left 0.3s;
    }

    .sidebar-visible {
        left: 0;
    }
}
</style>

<script>
import Sidebar from '../components/Sidebar.vue';
import Topbar from '@/components/Topbar.vue';
export default {
    name: 'TemplateComponent',
    props: {
        title: {
            default: '',
        },
        sidebarMenu: {
            default: '',
        },
    },
    data() {
        return {
            isOnline: navigator.onLine,
            isSidebarVisible: false,
        };
    },
    created() {
        window.addEventListener('online', this.updateOnlineStatus);
        window.addEventListener('offline', this.updateOnlineStatus);
    },
    unmounted() {
        window.removeEventListener('online', this.updateOnlineStatus);
        window.removeEventListener('offline', this.updateOnlineStatus);
    },
    methods: {
        updateOnlineStatus() {
            this.isOnline = navigator.onLine;
        },
        toggleSidebar() {
            this.isSidebarVisible = !this.isSidebarVisible;
        }
    },

    components: { Sidebar, Topbar },
};
</script>
